import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectQuotationsTransactions } from 'app/selectors/ugc/QuotationsSelector';
import QuotationsActions from 'app/actions/QuotationsActions';
import ModalActions from 'app/actions/ModalActions';
import { getIsLoadingFromUgcTransactions } from 'app/helpers/bib/bibHelpers';
import DeleteQuotationModal from './DeleteQuotationModal';

export class DeleteQuotationModalContainer extends React.PureComponent {
  render() {
    return <DeleteQuotationModal {...this.props} />;
  }
}

DeleteQuotationModalContainer.propTypes = {
  // ownProps
  quotationId: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleSuccess: PropTypes.func,

  // Redux props
  quotationsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  isLoading: PropTypes.bool.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = (state, ownProps) => ({
  isLoading: getIsLoadingFromUgcTransactions(
    selectQuotationsTransactions(state),
    ownProps.catalogBib.get('metadataId'),
    ownProps.quotationId
  )
});

const mapDispatchToProps = dispatch => ({
  quotationsActions: bindActionCreators(QuotationsActions, dispatch),
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteQuotationModalContainer);
